import { supabase as typedSupabase } from "@/integrations/supabase/client";

// Re-export as `any` to preserve compatibility with the existing codebase
// that was built against an external Supabase schema. Tables in this Cloud
// project should be created via migrations as features are wired up.
export const supabase: any = typedSupabase;

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;
